
                import "css-modules://src_components_timeline"
                export default {"Main":"_fce1e2","Wrapper":"_bedaeb","Line":"_084b1d","Inner":"_d43144","Item":"_2adfe9","Even":"_381044","Year":"_029a8c","Label":"_440ece"}
            